import React, { PureComponent } from "react";
import cx from "classnames";

import Icon from "./Icon";

export default class ListItem extends PureComponent {
  onPress = () => {
    const { onPress, id } = this.props;

    onPress(id);
  };

  render() {
    const { title, disabled, active } = this.props;

    return (
      <a
        className={cx("litem", { active, disabled })}
        onClick={disabled ? undefined : this.onPress}
      >
        <div className="litem__title">{title}</div>
        {disabled && <small className="u-xsmall">coming soon</small>}
        {!disabled && (
          <Icon name="keyboard_arrow_right" className="litem__icon" />
        )}
      </a>
    );
  }
}
